import { UserMenuLayout } from "./UserMenuLayout"
import type { UserMenuImplementationProps } from "./userMenu.model"

export const DefaultMenu = (props: UserMenuImplementationProps) => {
  return <UserMenuLayout {...props} />
}
